<template>
  <div class="contents_header support">
    <div class="txt_box">
      <h5>후원활동</h5>
      <p>
        지역사회의 어려운 이웃들에게 꿈과 희망을 전합니다. <br />
        더불어서 함께 살아가는 세상을 위해 같이 동참하셔서 작은 실천으로 큰
        사랑을 나누어 주세요.
      </p>
    </div>
  </div>
  <div class="support_wrap">
    <h5 class="tit">나눔으로 희망을 이어 주세요</h5>
    <ul class="filter">
      <li>
        <a
          @click="getCategorizedSponsor('')"
          :class="currentCategorySeq === '' ? 'active' : ''"
          >전체{{ getCurrentCategoryCount("") }}</a
        >
      </li>
      <li v-for="(category, index) in categories">
        <a
          v-if="index !== categories.length - 1"
          @click="getCategorizedSponsor(category.categorySeq)"
          :class="currentCategorySeq === category.categorySeq ? 'active' : ''"
          >{{ category.name
          }}{{ getCurrentCategoryCount(category.categorySeq) }}</a
        >
        <a
          v-else
          @click="getSponsorDonateList(category.categorySeq)"
          >{{ category.name}}
        </a>
      </li>
    </ul>
    <!--
    <div class="imgBox_area">
      <div class="img_box">
        <div class="img_wrap">
          <img
            src="../../assets/images/common/support_img_01.png"
            alt="결식아동 후원활동"
          />
        </div>
        <h5>결식아동 후원활동</h5>
        <p>더불어서 함께 살아가는 행복한 세상</p>
      </div>
      <div class="img_box">
        <div class="img_wrap">
          <img
            src="../../assets/images/common/support_img_02.png"
            alt="결식아동 후원활동"
          />
        </div>
        <h5>결식아동 후원활동</h5>
        <p>더불어서 함께 살아가는 행복한 세상</p>
      </div>
    </div>
    -->

    <div class="support_gallery_wrap">
      <ul class="support_gallery">
        <li
          v-for="sponsor in sponsors"
        >
          <a @click="toDetail(sponsor.sponsorSeq)">
            <div class="img">
              <img v-if="sponsor.thumbnailPath" :src="$getImgUrl(sponsor.thumbnailPath)" alt="">
              <img v-else src="../../assets/images/common/support_item_01.png" alt="">
            </div>
            <div class="txt">
              <div class="tit">
                <span>[{{ sponsor.category }}]</span>
                {{ $truncateText(sponsor.sponsorTitle, 14) }}
              </div>
              <p>{{ $truncateText(sponsor.sponsorContent, 20) }}</p>
              <div class="sum">
                <span>후원액</span>
                <p>{{ $addComma(sponsor.sponsorAmount) }} 원</p>
              </div>
            </div>
          </a>
        </li>

      </ul>
      <CustomerServicePagination
        :totalPages = "totalPages()"
        :currentPage = currentPage
        @changePage = "changePage"
      />
    </div>


  </div>
</template>
<script>
import { mapActions, mapState } from "vuex";
import CustomerServicePagination from "../common/CustomerServicePagination.vue";

const sponsorModule = "sponsorModule";
const categoryModule = "categoryModule";

export default {
  components: {
    CustomerServicePagination,
  },

  data() {
    return {
      currentPage: 1,
      currentCategorySeq: "",
    };
  },

  methods: {
    ...mapActions(sponsorModule, ["requestSponsorList"]),

    ...mapActions(categoryModule, ["requestCategoryList", "removeCategories"]),

    async getCategorizedSponsor(categorySeq) {
      this.currentPage = 1
      this.currentCategorySeq = categorySeq
      const {currentPage, currentCategorySeq} = this
      await this.requestSponsorList({currentPage, currentCategorySeq})
    },

    getSponsorDonateList(categorySeq) {
      this.currentCategorySeq = categorySeq
      this.$router.push({ name: "SponsorDonateListPage", params: {categorySeq: categorySeq} });
    },

    getCurrentCategoryCount(categorySeq) {
      if (this.currentCategorySeq === categorySeq) {
        return '(' + this.sponsorCount + ')'
      }
      else return ''
    },

    totalPages () {
      return Math.ceil(this.sponsorCount / 8);
    },

    async changePage (page) {
      this.currentPage = page
      const {currentPage, currentCategorySeq} = this
      await this.requestSponsorList({currentPage, currentCategorySeq})
    },

    toDetail(sponsorSeq) {
      this.$router.push({
        name: 'SponsorDtlPage',
        params: { sponsorSeq: sponsorSeq.toString() }
      })
    }
  },

  computed: {
    ...mapState(sponsorModule, ["sponsors", "sponsorCount"]),

    ...mapState(categoryModule, ["categories"]),
  },

  async mounted() {
    const { currentPage, currentCategorySeq } = this;
    await this.requestSponsorList({ currentPage, currentCategorySeq });
    await this.requestCategoryList("후원활동");
  },
};
</script>
<style lang=""></style>
